import { z } from 'zod'

import {
  SOURCE_DELIMITER,
  type WalletBackendIdentifierString as SourceIdentifier,
} from 'api/types/walletApiTypes'
import DataSource from 'constants/sources/DataSource'

const dataSourceValues = Object.values(DataSource).join('|')
const sourceValueRegex = new RegExp(`^.*${SOURCE_DELIMITER}(${dataSourceValues})$`)

export const filtersSourceSchema = z.custom<SourceIdentifier>((value: string) => {
  return sourceValueRegex.test(value)
})

export const filterAssetSchema = z.string()

export const filterSourceTagSchema = z.string()

export const dashboardUrlFiltersSchema = z.object({
  sources: z.array(z.string()).catch([]),
  sourceTags: z.array(filterSourceTagSchema).catch([]),
  assets: z.array(filterAssetSchema).catch([]),
  start: z.string().optional().catch(undefined),
  end: z.string().optional().catch(undefined),
  version: z.string().optional(),
})

export type ValidSourceType = z.infer<typeof filtersSourceSchema>

export type ValidAssetType = z.infer<typeof filterAssetSchema>

export type ValidSourceTagType = z.infer<typeof filterSourceTagSchema>

export type DashboardUrlFilters = z.infer<typeof dashboardUrlFiltersSchema>

export const dashboardFiltersSchema = z.object({
  sources: z.array(z.string()),
  sourceTags: z.array(filterSourceTagSchema),
  assets: z.array(filterAssetSchema),
  dateRange: z.object({
    startDate: z.string().optional(),
    endDate: z.string().optional(),
  }),
  version: z.string().optional(),
})

export type DashboardFilters = z.infer<typeof dashboardFiltersSchema>
